<div class="mobile-navigation-sidebar">
    <div class="top-bar">
        <lsq-icon
            class="company-logo"
            [type]="icons.FastTrackLogo"
            [color]="color.White"
        ></lsq-icon>
    </div>
    <ul class="parent-group" iosNestedScroll>
        <ng-container *ngFor="let navigationItem of state.navigationItems">
            <ng-container
                *ngIf="
                    ((isLoggedIn$ | async) || navigationItem.allowAnonymous) &&
                    !navigationItem.hideInMobile
                "
            >
                <ng-container *featureFlag="navigationItem.featureFlags">
                    <ng-container *environments="navigationItem.environments">
                        <li
                            *claimsOr="navigationItem.claims"
                            (click)="closeActionSheet()"
                            class="mobile-nav-item"
                            [routerLinkActive]="navigationItem.routerLinkActive"
                            [routerLinkActiveOptions]="navigationItem.routerLinkActiveOptions"
                        >
                            <lsq-mobile-navigation-item
                                [label]="navigationItem.label"
                                [routerLink]="navigationItem.routerLink"
                                [queryParams]="navigationItem.queryParams"
                                [externalLink]="navigationItem.externalLink"
                                [showCaret]="!navigationItem.children?.length"
                            >
                            </lsq-mobile-navigation-item>

                            <ul class="child-group">
                                <li
                                    *ngFor="let child of navigationItem.children"
                                    class="mobile-nav-sub-item"
                                >
                                    <lsq-mobile-navigation-item
                                        [label]="child.label"
                                        [routerLink]="child.routerLink"
                                        [queryParams]="child.queryParams"
                                        [externalLink]="child.externalLink"
                                        [isChild]="true"
                                        [showCaret]="true"
                                    >
                                    </lsq-mobile-navigation-item>
                                </li>
                            </ul>
                        </li>
                    </ng-container>
                </ng-container>
            </ng-container>
        </ng-container>
    </ul>
</div>
